import { matchPath } from 'react-router-dom';
const publicRoutes = ['/signup', '/invite/:id', '/logout', '/company-creation', '/signed-out', '/auth/sso'];
/**
 * Check if the current URL is public (not requiring auth)
 */
export function isPublicRoute() {
    const match = matchPath(window.location.pathname, { path: publicRoutes });
    return Boolean(match);
}
